import { Buildings } from 'phosphor-react';
import React from 'react';
import * as S from '../styles';

interface PartnerProps {
  partner: {
    id: string;
    name: string;
    image?: { url: string };
    parent?: any;
  };
  onSelect: (id: string) => void;
}

export const PartnerCard: React.FC<PartnerProps> = ({ partner, onSelect }) => {
  return (
    <S.Card
      onClick={() => onSelect(partner.id)}
      tabIndex={0}
      role="button"
      aria-label={`Select ${partner.name}`}
      onKeyDown={(e) => e.key === 'Enter' && onSelect(partner.id)}
    >
      <S.Avatar url={partner.image?.url || ''} />
      <S.PartnerInfo>
        <S.Name>{partner.name}</S.Name>
        <S.PartnerId>#{partner.id}</S.PartnerId>
      </S.PartnerInfo>
      {partner.parent && (
        <S.DepartmentIcon title="Department">
          <Buildings weight="fill" />
        </S.DepartmentIcon>
      )}
    </S.Card>
  );
};
